import { FC, MutableRefObject } from 'react'
import { Box, IconButton } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useTranslation } from 'react-i18next'
import { IdoorAccess } from '../../API/types'
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { DeleteOutline, Edit, History, VpnKey } from '@mui/icons-material'
import { appUrl, DATETIME_FORMAT } from '../../API/utils'
import dayjs from 'dayjs'
import { GridApiCommunity } from '@mui/x-data-grid/internals'

const useStyles = makeStyles()(({ spacing }) => ({
  box: {
    margin: spacing(0.5),
  },
}))

interface DoorAccessTableProps {
  roomsListData: IdoorAccess[]
  dataGridRef: MutableRefObject<GridApiCommunity>
  handleEditDoorAccess: (id: string) => void
  handleClickOpenDelete: (id: string) => void
  handleClickOpenLog: (id: string) => void
}

const DoorAccessTable: FC<DoorAccessTableProps> = ({
  roomsListData,
  dataGridRef,
  handleEditDoorAccess,
  handleClickOpenDelete,
  handleClickOpenLog,
}) => {
  const { t } = useTranslation('')
  const { classes } = useStyles()

  const columns: GridColDef[] = [
    { field: 'comments', headerName: t('Vārds, telefons, kommentārs'), width: 350 },
    {
      field: 'dateFrom',
      headerName: t('Datums no'),
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return dayjs(params.row?.dateFrom).format(DATETIME_FORMAT)
      },
    },
    {
      field: 'dateTo',
      headerName: t('Datums līdz'),
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return dayjs(params.row?.dateTo).format(DATETIME_FORMAT)
      },
    },
    {
      field: 'actions',
      headerName: t('Actions'),
      width: 170,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <IconButton href={appUrl + '?key=' + params.row?.key} component={'a'} target={'_blank'} color={'primary'}>
              <VpnKey />
            </IconButton>
            <IconButton color={'primary'} onClick={() => handleEditDoorAccess(params.row?.id)}>
              <Edit />
            </IconButton>
            <IconButton color={'primary'} onClick={() => handleClickOpenLog(params.row?.id)}>
              <History />
            </IconButton>
            <IconButton
              color='error'
              component='div'
              sx={{}}
              onClick={() => {
                handleClickOpenDelete(params.row.id)
              }}
            >
              <DeleteOutline />
            </IconButton>
          </>
        )
      },
    },
  ]

  return (
    <>
      <Box
        sx={
          {
            //display: 'flex',
            //flexWrap: 'wrap',
            //maxWidth: 300,
          }
        }
      >
        <Box className={classes.box}>
          <DataGrid
            apiRef={dataGridRef}
            rows={roomsListData}
            columns={columns}
            rowSelection={false}
            disableColumnMenu={true}
            hideFooter={true}
            autoHeight={true}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 100 },
              },
            }}
            pageSizeOptions={[50, 10]}
          />
        </Box>
      </Box>
    </>
  )
}

export default DoorAccessTable
